import { Reducer } from 'redux';
import ConfigureArchitectureState from '../state/ConfigureArchitectureState';
import IConfigureArchitectureState from '../state/ConfigureArchitectureState';
import {
  ConfigureArchitectureAction,
  ConfigureArchitectureActionTypes,
} from '../actions/ConfigureArchitectureActions';
import { IRowsData } from '../../../pages/Migrate/DiscoverTab/EditableTable';
import { ISummaryPayload } from '../../models/ConfigureArchitectureModels';

export const initialState: IConfigureArchitectureState = {
  error: '',
  loading: false,
  sourceData: undefined,
  savedSourceData: undefined,
  targetData: undefined,
  savedTargetData: undefined,
  summary: undefined,
};

export const configureArchitectureReducer: Reducer<ConfigureArchitectureState> = (
  state = initialState,
  action: ConfigureArchitectureAction,
) => {
  switch (action.type) {
    case ConfigureArchitectureActionTypes.SEND_SOURCE_DATA_START:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case ConfigureArchitectureActionTypes.SEND_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        savedSourceData: action.data as IRowsData[],
      };
    case ConfigureArchitectureActionTypes.SEND_SOURCE_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data,
      };

    // To get source tab saved data
    case ConfigureArchitectureActionTypes.GET_SOURCE_DATA_START:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case ConfigureArchitectureActionTypes.GET_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        sourceData: action.data as IRowsData[],
      };
    case ConfigureArchitectureActionTypes.GET_SOURCE_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    // To update source tab saved data
    case ConfigureArchitectureActionTypes.UPDATE_SOURCE_DATA_START:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case ConfigureArchitectureActionTypes.UPDATE_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
      };
    case ConfigureArchitectureActionTypes.UPDATE_SOURCE_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data,
      };

    // To get target tab saved data
    case ConfigureArchitectureActionTypes.GET_TARGET_DATA_START:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case ConfigureArchitectureActionTypes.GET_TARGET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        targetData: action.data as IRowsData[],
      };
    case ConfigureArchitectureActionTypes.GET_TARGET_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    
      // To save response of target data 
    case ConfigureArchitectureActionTypes.SEND_TARGET_DATA_START:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case ConfigureArchitectureActionTypes.SEND_TARGET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        savedTargetData: action.data as IRowsData[],
      };
    case ConfigureArchitectureActionTypes.SEND_TARGET_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data,
      };

    // To summary tab data
    case ConfigureArchitectureActionTypes.GET_SUMMARY_DATA_START:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case ConfigureArchitectureActionTypes.GET_SUMMARY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        summary: action.data as any as ISummaryPayload,
      };
    case ConfigureArchitectureActionTypes.GET_SUMMARY_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data,
      };

    default:
      return state;
  }
};
